const BASE_URL = 'https://file.40017.cn/appresource/propublic/eabout/license';
console.log(process.env.VUE_APP_BASE_H5_URL);
const isLocal = process.env.VUE_APP_ENV == 'development';
const ua = window.navigator.userAgent;
const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

// 营业执照
export const licenses = {
  hd: {
    title: '北京同程华鼎国际旅行社有限公司',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicense?wvc3=1&tag=hd`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicense?wvc3=1&tag=hd`,
    images: [`${BASE_URL}/huadingguoji/2384/img1.png`, `${BASE_URL}/huadingguoji/2384/img2.png`],
  },
  ei: {
    title: '北京艺龙信息技术有限公司',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicense?wvc3=1&tag=ei`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicense?wvc3=1&tag=ei`,
    images: [
      `${BASE_URL}/elongxinxi/2384/img1.png`,
      `${BASE_URL}/elongxinxi/2384/icp/ICP_01.jpg`,
      `${BASE_URL}/elongxinxi/2384/icp/ICP_02.jpg`,
      `${BASE_URL}/elongxinxi/2384/icp/ICP_03.jpg`,
      `${BASE_URL}/elongxinxi/2384/icp/ICP_04.jpg`,
      `${BASE_URL}/elongxinxi/2384/icp/ICP_05.jpg`,
      `${BASE_URL}/elongxinxi/2384/icp/ICP_06.jpg`,
      `${BASE_URL}/elongxinxi/2384/icp/ICP_07.jpg`,
      `${BASE_URL}/elongxinxi/2384/icp/ICP_08.jpg`,
    ],
  },
  tytx: {
    title: '南京同游天下汽车租赁有限公司',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicense?wvc3=1&tag=tytx`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicense?wvc3=1&tag=tytx`,
    images: [
      `${BASE_URL}/nanjingtonyourtianxia/2384/img4.jpg`
    ],
  },
  chw: {
    title: '苏州程会玩国际旅行社有限公司',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicense?wvc3=1&tag=chw`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicense?wvc3=1&tag=chw`,
    images: [`${BASE_URL}/chenhuiwan/2384/img1.png`, `${BASE_URL}/chenhuiwan/2384/img2.png`],
  },
  cltx: {
    title: '苏州创旅天下信息技术有限公司',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicense?wvc3=1&tag=cltx`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicense?wvc3=1&tag=cltx`,
    images: [`${BASE_URL}/chuanglvtianxia/2384/img1.png`],
  },
  bxdl: {
    title: '同程保险代理有限公司',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicense?wvc3=1&tag=bxdl`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicense?wvc3=1&tag=bxdl`,
    images: [`${BASE_URL}/baoxiandaili/2384/img4.jpg`, `${BASE_URL}/baoxiandaili/2384/img8.jpg`],
  },
  tcc: {
    title: '同程网络科技股份有限公司',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicense?wvc3=1&tag=tcc`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicense?wvc3=1&tag=tcc`,
    images: [`${BASE_URL}/tc/2384/img1.jpg`],
  },
  ec: {
    title: '艺龙网信息技术（北京）有限公司',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicense?wvc3=1&tag=ec`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicense?wvc3=1&tag=ec`,
    images: [`${BASE_URL}/elong/2384/img1.jpg`],
  },
};

// 业务协议与交易规则
export const business = [
  {
    title: '艺龙旅行酒店服务条款',
    jumpUrl: isLocal
      ? `${window.location.origin}/ehotelserve?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/ehotelserve?wvc3=1`,
  },
  {
    title: '12306会员开通协议',
    jumpUrl: isLocal
      ? `${window.location.origin}/emember?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/emember?wvc3=1`,
  },
  {
    title: '火车票信息服务协议',
    jumpUrl: isLocal
      ? `${window.location.origin}/etrainserve?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/etrainserve?wvc3=1`,
  },
  {
    title: '艺龙旅行机票预订服务协议',
    jumpUrl: isLocal
      ? `${window.location.origin}/eflightbook?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/eflightbook?wvc3=1`,
  },
  {
    title: '用车产品预订服务协议',
    jumpUrl: isLocal
      ? `${window.location.origin}/ecarbook?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/ecarbook?wvc3=1`,
  },
];

// 服务协议
export const agreements = [
  {
    title: '艺龙旅行服务协议',
    jumpUrl: isLocal
      ? `${window.location.origin}/eserve?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/eserve?wvc3=1`,
  },
  {
    title: '艺龙旅行免责说明',
    jumpUrl: isLocal
      ? `${window.location.origin}/exemption?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/exemption?wvc3=1`,
  },
  {
    title: '艺龙旅行隐私政策',
    // 研发中心赵华提供，PM 张亚会
    jumpUrl: `https://privacy-policy-w.elong.com/privacyApp/link/latest/versionHtml?wvc3=1&type=0&appkey=${
      isAndroid ? 'DEMlwFHivkPw' : '1oUFjkSvR2IN'
    }`,
  },
  {
    title: '软件许可使用协议',
    jumpUrl: isLocal ? `${window.location.origin}/euse?wvc3=1` 
    : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/euse?wvc3=1`,
  },
  {
    title: '业务协议与交易规则',
    jumpUrl: isLocal ? `${window.location.origin}/businessagreement?wvc3=1`
    : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/businessagreement?wvc3=1`,
  },
];

// 关于艺龙跳转
export const abouts = [
  {
    title: '服务协议',
    jumpUrl: isLocal
      ? `${window.location.origin}/publicagreement?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/publicagreement?wvc3=1`,
  },
  {
    title: '营业执照',
    jumpUrl: isLocal
      ? `${window.location.origin}/elicenses?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/elicenses?wvc3=1`,
  },
  {
    title: 'ICP备案',
    jumpUrl: isLocal
      ? `${window.location.origin}/eicp?wvc3=1`
      : `https:${process.env.VUE_APP_BASE_H5_URL}/propublic/eicp?wvc3=1`,
  },
];

// 艺龙相关应用
export const relatedappsEl = [
  {
    logo: 'https://file.40017.cn/appresource/propublic/eabout/relatedapp/img_logo_tongcheng.png',
    title: '同程旅行客户端',
    desc: '同程旅行，新一代旅行平台。作为中国优质在线旅行服务提供商之一，为2亿用户，随时随地提供专业的机票、酒店、火车票、汽车票、门票、国内外度假线路等全方面旅游产品的在线预订服务，让用户享受更便捷、舒适的旅行。',
  },
  {
    logo: 'https://file.40017.cn/appresource/propublic/eabout/relatedapp/logo_tc.png',
    title: '同程旅行主小程序',
    desc: '同程旅行官方小程序，是小程序旅行预订的领导者，为2亿用户，随时随地提供专业的机票、酒店、火车票、汽车票、门票、国内外度假线路等全方面旅游产品的在线预订服务。',
  },
  {
    logo: 'https://file.40017.cn/appresource/propublic/eabout/relatedapp/logo_elong_red.png',
    title: '艺龙小程序',
    desc: '艺龙旅行是中国领先的一站式在线住宿及出行预订服务提供商之一，服务范围已覆盖全国及海外各个住宿及出行场景，可以为用户提供超过110万家酒店及非标住宿预订服务。',
  },
];


// 同程相关应用
export const relatedappsTC = [
  {
    logo: 'https://file.40017.cn/appresource/propublic/eabout/relatedapp/logo_elong_b.png',
    title: '艺龙旅行客户端',
    desc: '艺龙旅行网官方客户端，为您提供给力的酒店折扣，贴心的机票、火车票预订，有问必答的热情客服，是您的随身酒店专家。',
  },
  {
    logo: 'https://file.40017.cn/appresource/propublic/eabout/relatedapp/logo_tc.png',
    title: '酒店机票火车票 小程序',
    desc: '同程旅行官方小程序，提供飞机票、火车票、汽车票、酒店、景点门票及船票预订服务，品质旅游让您旅行预订更放心。',
  },
  {
    logo: 'https://file.40017.cn/appresource/propublic/eabout/relatedapp/logo_elong_red.png',
    title: '艺龙酒店机票火车票预订 小程序',
    desc: '艺龙旅行网提供旅游预订服务，110家酒店，住宿，宾馆订房及团购，包括如家，7天，汉庭等连锁酒店，航空飞机，铁路火车，动车，高铁票。',
  },
  {
    logo: 'https://file.40017.cn/appresource/propublic/eabout/relatedapp/logo_elong_a.png',
    title: '艺龙钟点房小时房预订 小程序',
    desc: '艺龙旅行旗下，钟点房预订。提供全国优质钟点房预订服务。',
  },
];
